import React, { useState, useEffect } from "react";
import { getStudentIdDataRead } from "../../../../lib/studentbooklistview";

export default function BookList({ slug }) {
  const [studentBookList, setStudentBookList] = useState();

  async function GetData() {
    const info = await getStudentIdDataRead(slug);
    setStudentBookList(info);
    console.log("BoookList", info);
  }

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div className="settings-widget">
      <div className="settings-inner-blk p-0">
        <div className="checkout-form personal-address add-course-info">
          <div className="personal-info-head">
            <h4>List of Recommended Books</h4>
          </div>
          <div className="comman-space pb-0">
            <div className="settings-referral-blk course-instruct-blk  table-responsive">
              {/* Instructor Users */}
              <table className="table table-nowrap mb-0">
                <thead>
                  <tr>
                    <th>TITLE</th>
                    <th>AUTHOR</th>
                  </tr>
                </thead>
                <tbody>
                  {studentBookList
                    ? studentBookList.map(function (data) {
                        return (
                          <tr key={data.bookId}>
                            <td>{data.title}</td>
                            <td>{data.author}</td>
                          </tr>
                        );
                      })
                    : ""}
                </tbody>
              </table>
              {/* Instructor List */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
